const SessionDefaults = {
    identityContext: {
        attributes: {},
    },
};
export default SessionDefaults;
